import { render, staticRenderFns } from "./fileload.vue?vue&type=template&id=6978b1fa&scoped=true&"
import script from "./fileload.vue?vue&type=script&lang=js&"
export * from "./fileload.vue?vue&type=script&lang=js&"
import style0 from "./fileload.vue?vue&type=style&index=0&id=6978b1fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978b1fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6978b1fa')) {
      api.createRecord('6978b1fa', component.options)
    } else {
      api.reload('6978b1fa', component.options)
    }
    module.hot.accept("./fileload.vue?vue&type=template&id=6978b1fa&scoped=true&", function () {
      api.rerender('6978b1fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/sys/file_loader/fileload.vue"
export default component.exports